module.exports = __webpack_public_path__ + "assets/img/coffe-cup-donn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/coffe-cup-donn.jpg
// module id = 1923
// module chunks = 0